//
// Module for the Index view (Fund and Participant Workflow Activity pages)
//
rs.module("framework/content/workflow/index",

    [],

    function () {

        // Initialize the module
        function initialize(jsSelectors, backendUrl, workflowStarted) {

            const workflowStartedTimeout = 1000;
            const normalTimeout = 10000;

            var filter = $.js(jsSelectors.filter);
            var gridContent = $.js(jsSelectors.gridContent);
            var statusSelect = filter.js(jsSelectors.statusSelect);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            // Create a variable to hold the timeout for refreshing the grid
            var refreshTimer;

            // Initialize the refresh timer when the page first displays. If a workflow was just started,
            // refresh the grid in 1 second in case the workflow was slow to start. Else, refresh after 10 seconds.  
            refreshTimer = setupTimer(workflowStarted ? workflowStartedTimeout : normalTimeout);

            //
            // Setup refresh timer for delayed grid refresh
            //
            function setupTimer(timeout) {
                return setTimeout(refreshWorkflowInstancesGrid, timeout);
            }

            // Register statusSelect change event handler to reload grid html
            statusSelect.change(refreshWorkflowInstancesGrid);

            //
            // Refresh the Workflow Instances grid
            //
            function refreshWorkflowInstancesGrid() {

                // Reset the refresh timer
                clearTimeout(refreshTimer);

                loadingSpinner.show();

                $.get(backendUrl, { workflowInstanceStatus: statusSelect.val()})
                    .done(function (html) {
                        gridContent.html(html);
                    })
                    .always(function () {
                        loadingSpinner.hide();

                        // Setup a new refresh timer to run in 10 seconds to check again for updated workflows
                        refreshTimer = setupTimer(normalTimeout);
                    });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);